import {
  Navbar,
  NavbarContent,
  NavbarBrand,
  NavbarItem,
  Link,
} from "@nextui-org/react";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../components/Logo";
import "./index.css";

const DESKTOP_NAV_CLASSNAMES = {
  wrapper: "site-container !max-w-site",
  brand: "flex-grow-0 basis-auto p-0 m-0",
  content:
    "gap-0 px-0 data-[justify=start]:flex-grow-0 data-[justify=start]:basis-auto data-[justify=end]:flex-grow data-[justify=end]:basis-0",
};

function Nav() {
  return (
    <Navbar
      isBordered
      maxWidth="xl"
      classNames={DESKTOP_NAV_CLASSNAMES}
      className="hidden laptop:flex navbar stroke tracking-widest"
    >
      <NavbarContent justify="start">
        <NavbarBrand>
          <Link as={RouterLink} to="/" className="p-0">
            <Logo></Logo>
          </Link>
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent justify="end">
        <NavbarItem className="mr-6">
          <Link
            as={RouterLink}
            className="text-black hover:opacity-100"
            to="/about"
          >
            About
          </Link>
        </NavbarItem>
        <NavbarItem className="mr-6">
          <Link
            as={RouterLink}
            className="text-black hover:opacity-100"
            to="/work"
          >
            Work
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link
            as={RouterLink}
            className="text-black hover:opacity-100"
            to="/blog"
          >
            Blog
          </Link>
        </NavbarItem>
      </NavbarContent>
    </Navbar>
  );
}

export default Nav;
